const SESSION_STORAGE_CONSENT_BANNER_ERROR_CLOSED_KEY = 'consentBannerErrorClosed';
export const setErrorBannerCloseStatus = (status: 'true' | 'false') => {
    sessionStorage.setItem(SESSION_STORAGE_CONSENT_BANNER_ERROR_CLOSED_KEY, status);
};

export const getErrorBannerCloseStatus = () => {
    return sessionStorage.getItem(SESSION_STORAGE_CONSENT_BANNER_ERROR_CLOSED_KEY);
};
